import React from "react";

const ChevronRight = () => {
  return (
    <svg
      className="chevron-right-icon"
      width="9"
      height="17"
      viewBox="0 0 9 17"
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.900104 16.8003C0.72468 16.8003 0.55308 16.7491 0.4064 16.6528C0.259721 16.5566 0.144355 16.4196 0.0744835 16.2587C0.00461165 16.0978 -0.0167204 15.92 0.0131107 15.7471C0.0429418 15.5743 0.122636 15.4139 0.242395 15.2857L6.66915 8.39995L0.242395 1.5142C0.16173 1.42783 0.0988671 1.32641 0.0573955 1.21574C0.0159239 1.10508 -0.00334558 0.987326 0.000690052 0.869213C0.00472568 0.751099 0.0319866 0.634937 0.080915 0.527359C0.129844 0.419781 0.199482 0.322894 0.285854 0.242229C0.372226 0.161564 0.473641 0.098701 0.584308 0.0572294C0.694975 0.0157578 0.812728 -0.00351077 0.930841 0.000524861C1.04895 0.0045605 1.16512 0.0318214 1.27269 0.0807499C1.38027 0.129678 1.47716 0.199316 1.55782 0.285689L8.55783 7.78569C8.71338 7.9524 8.79989 8.17193 8.79989 8.39994C8.79989 8.62796 8.71338 8.84748 8.55783 9.0142L1.55782 16.5142C1.47375 16.6045 1.37195 16.6766 1.25878 16.7258C1.14562 16.775 1.02351 16.8004 0.900104 16.8003Z" />
    </svg>
  );
};

export default ChevronRight;
